/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useEffect } from "react";
import { AUTH_COOKIE_TOKEN } from "~/utils/constant";
import useCheckRouteIsHome from "~/hook/useCheckRouteIsHome";
import { setIsUserLoginTrue } from "~/lib/store/slice/loginSlice";
import { useAppDispatch, useAppSelector } from "~/lib/store/store";
import { cn } from "~/lib/utils";
import { deleteCookie, getCookie } from "~/utils/cookies";
import { LoginDialog } from "../login/Login";
import ChangeLanguage from "./ChangeLanguage";
import HeaderImage from "./HeaderImage";
import ProfileComponent from "./ProfileComponent";
import SearchBar from "./SearchBar";

const WebHeader = ({ isLogin, isSticky = true, isSupperHeader = false }: { isLogin: boolean; isSticky?: boolean; isSupperHeader?: boolean }) => {
  const { isUserLogin } = useAppSelector((state) => state.login);
  const dispatch = useAppDispatch();
  const { isHome } = useCheckRouteIsHome();

  useEffect(() => {
    const token = getCookie(AUTH_COOKIE_TOKEN);
    if (token) {
      dispatch(setIsUserLoginTrue());
    } else {
      deleteCookie(AUTH_COOKIE_TOKEN);
    }
  }, []);

  // useEffect(() => {
  //   isUserLogin ? setUserLogin(true) : setUserLogin(false);
  // }, [isUserLogin]);

  return (
    <div className={cn("w-full h-full px-3 flex items-center justify-between")}>
      {/* {!isHome && (
        <div className="sm:hidden">
          <BackButton isSticky={isSticky} />
        </div>
      )} */}

      <HeaderImage />

      <div className="max-lg:hidden">
        <SearchBar isSupperHeader={isSupperHeader} />
      </div>

      <div className="flex gap-[11px] justify-center items-center ">
        <ChangeLanguage variant="footer" />
        {/* <LoginButton /> */}
        {!(isLogin || isUserLogin) ? <LoginDialog isDisplayLoggingIcon={true} /> : <ProfileComponent isDisplayLoggingIcon={true} />}
      </div>
    </div>
  );
};

export default WebHeader;
